module.exports = __webpack_public_path__ + "static/media/Bedroom4-2.7519ed81.jpg";